
// Enhanced 24-hour ambient gradient system with CSS classes
// Returns CSS class names for gradient and orb effects

export const getAmbientGradientClass = (hour) => {
  return `gradient-hour-${hour}`;
};

export const getCurrentHour = () => {
  return new Date().getHours();
};
